import React from 'react';
import { Card, Panel } from '@/components/Bicester';
import { ItemDataType } from 'rsuite5/esm/@types/common';

const CasesInfo = ({ casesBasic, brandList }: { casesBasic: any; brandList: ItemDataType[] }) => {
  return (
    <Panel title="投诉信息" leftShadow>
      <Card smDivider>
        <div className="flex">
          <Card.DatePicker required label="投诉发生日期" formKey="cases_day" />
          <Card.Picker
            required
            label="投诉来源"
            formKey="cases_source"
            pickerData={casesBasic.source}
            searchable
          />
          <Card.Picker label="被投诉对象" formKey="cases_brand" pickerData={brandList} searchable />
          <Card.CheckPicker
            label="投诉问题分类"
            formKey="cases_category"
            pickerData={casesBasic.category}
            groupBy="role"
            renderMenuGroup={(title, node) => `${title} - 至少选择一项`}
            searchable
            placement="bottomEnd"
          />
        </div>
        <div className="flex">
          <Card.DatePicker required label="投诉接收日期" formKey="cases_receive_day" />
          <Card.Input
            className="flex-[3]"
            label="投诉具体描述"
            formKey="cases_remark"
            inputType="textarea"
            labelWeight={1}
            contentWeight={5}
          />
        </div>
      </Card>
    </Panel>
  );
};

export default CasesInfo;
